module.exports = __webpack_public_path__ + "static/media/H&Wlogo.02308db2.png";